import React from "react";

function Immunization() {
  return (
    <div className="card h-[370px] w-[370px] m-5 border rounded-lg">
      <div className="header h-[13%] bg-[#BEFBFF] flex items-center justify-center rounded p-2">
        <h1 className="font-bold text-normal text-[#0c3538] mt-3">Immunization</h1>
      </div>
      <div className="body h-[75%] overflow-y-auto bg-white scrollwidth border-t-2 border-t-[#69DCE4]">
        <div className="items-center text-sm p-2 m-3 border rounded-md">
          <div className="font-semibold">
            Immunisation :
            <span className="font-medium text-gray-500">
              Zoster (Shingles)
            </span>
          </div>
          <div className="ml-auto font-medium mt-2 flex justify-start">
            <h5 className="text-gray-500 font-semibold text-sm">
              Onset date: <span>2024-12-21</span>
            </h5>
          </div>
        </div>
        <div className="items-center text-sm p-2 m-3 border rounded-md">
          <div className="font-semibold">
            Immunisation :
            <span className="font-medium text-gray-500">
            Influenza(Flu)
            </span>
          </div>
          <div className="ml-auto font-medium mt-2 flex justify-start">
            <h5 className="text-gray-500 font-semibold text-sm">
              Onset date: <span>2024-12-21</span>
            </h5>
          </div>
        </div>
        <div className="items-center text-sm p-2 m-3 border rounded-md">
          <div className="font-semibold">
            Immunisation :
            <span className="font-medium text-gray-500">
            Tetanus, Diphtheria, Pertussis
            </span>
          </div>
          <div className="ml-auto font-medium mt-2 flex justify-start">
            <h5 className="text-gray-500 font-semibold text-sm">
              Onset date: <span>2024-12-21</span>
            </h5>
          </div>
        </div>
        <div className="items-center text-sm p-2 m-3 border rounded-md">
          <div className="font-semibold">
            Immunisation :
            <span className="font-medium text-gray-500">
              Zoster (Shingles)
            </span>
          </div>
          <div className="ml-auto font-medium mt-2 flex justify-start">
            <h5 className="text-gray-500 font-semibold text-sm">
              Onset date: <span>2024-12-21</span>
            </h5>
          </div>
        </div>
      </div>
      <div className="footer h-[44px] bg-[#BEFBFF] rounded"></div>
    </div>
  );
}

export default Immunization;
